var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wall-clock_1_",
    "data-name": "wall-clock (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.735,
    height: 43.735,
    viewBox: "0 0 43.735 43.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M417.677,377.065a1.708,1.708,0,0,0-2.39.351c-.31.416-.641.825-.985,1.214a1.708,1.708,0,1,0,2.56,2.263c.407-.461.8-.944,1.167-1.438A1.708,1.708,0,0,0,417.677,377.065Z",
    transform: "translate(-378.52 -344.547)",
    fill: "#24515e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M465.021,286.464a1.709,1.709,0,0,0-2.033,1.306c-.11.507-.244,1.015-.4,1.51a1.708,1.708,0,1,0,3.264,1.009c.182-.588.34-1.191.471-1.792A1.709,1.709,0,0,0,465.021,286.464Z",
    transform: "translate(-423.007 -261.958)",
    fill: "#24515e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M336.427,442.41c-.454.253-.923.49-1.4.7a1.708,1.708,0,1,0,1.406,3.114c.561-.253,1.117-.534,1.655-.834a1.708,1.708,0,0,0-1.666-2.983Z",
    transform: "translate(-305.493 -404.421)",
    fill: "#24515e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M163.569,77.708v12.96L157.3,96.933a1.708,1.708,0,0,0,2.416,2.416l6.765-6.765a1.708,1.708,0,0,0,.5-1.208V77.708a1.708,1.708,0,0,0-3.417,0Z",
    transform: "translate(-143.409 -69.508)",
    fill: "#24515e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M42.027,3.673a1.708,1.708,0,0,0-1.708,1.708v4.744a21.869,21.869,0,1,0-18.451,33.61l.043,0,.043,0c.616,0,1.237-.026,1.848-.077a1.708,1.708,0,1,0-.285-3.4c-.516.043-1.042.065-1.563.065l-.043,0-.043,0A18.451,18.451,0,1,1,37.75,12.471h-4.7a1.708,1.708,0,1,0,0,3.417h5.216a5.434,5.434,0,0,0,2.843-.8,1.705,1.705,0,0,0,.153-.1,5.466,5.466,0,0,0,2.471-4.57V5.381A1.708,1.708,0,0,0,42.027,3.673Z",
    fill: "#24515e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.86670aa5eee58d76a2c045f1a3f8702a.svg";
export { ForwardRef as ReactComponent };